import { createFileRoute } from '@tanstack/react-router';
import { FormsSettingsRouteView } from '@/pages/workspaces/integrations/forms/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/forms_/settings')({
  component: FormsSettingsRouteView,
});
